import Vue from "vue";

export const state = Vue.observable({
  filters: {
    options: {
      document_types_filter: [],
      sectors_filter: [],
      locations_filter: [],
      date_range_filter: [],
    },
    params: {
      dateRage: {},
      documentTypeId: {},
      location: {},
      sector: {},
      userId: {},
    },
  },
  isCheckAll: false
});

export const mutations = {
  cleanFilters: () => {
    state.filters.params.documentTypeId = {};
    state.filters.params.location = {};
    state.filters.params.sector = {};
    state.filters.options.document_types_filter = [];
    state.filters.options.sectors_filter = [];
    state.filters.options.locations_filter = [];
  },
  setDateRageFilter: (range) => {
    state.filters.options.date_range_filter = range
  },
  setOptions: (options) => {
    state.filters.options = {
      ...state.filters.options,
      ...options
    }
  },
  setDateRage: (value) => {
    state.filters.params.dateRage = value
  },
  setDocumentTypeId: (value) => {
    state.filters.params.documentTypeId = value
  },
  setLocation: (value) => {
    state.filters.params.location = value
  },
  setSector: (value) => {
    state.filters.params.sector = value
  },
  setUserId: (value) => {
    state.filters.params.userId = value
  },
  formatParams: () => {
    const params = {};
    const obj = state.filters.params;
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key].value) {
        if (key === "dateRage") {
          if (_.isArray(obj[key].value)) {
            params["dateFrom"] = obj[key].value[0];
            params["dateTo"] = obj[key].value[1];
          }
        } else {
          if (key !== "dateRage") {
            params[key] = `["${obj[key].value}"]`;
          }
        }
      }
    }
    return !_.isEmpty(params) ? params : false;
  },
}